var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2933 3685 c0 -8 7 -15 14 -15 8 0 11 -4 8 -10 -3 -5 1 -10 9 -10 9 0 16 -5 16 -12 0 -6 3 -9 6 -5 4 3 13 -1 21 -9 12 -12 18 -12 32 -2 9 7 13 9 9 4 -10 -12 20 -39 34 -30 7 4 10 4 6 -1 -7 -8 57 -47 80 -48 6 0 12 -3 12 -7 0 -4 17 -15 37 -26 43 -22 45 -23 97 -69 21 -19 43 -35 49 -35 14 0 -73 79 -140 127 -29 21 -53 43 -53 49 0 7 -15 19 -32 27 -29 14 -200 87 -204 87 0 0 -1 -7 -1 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3230 3561 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380 3396 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3430 3340 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20 -2 0 0 -9 6 -20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6433cd756f9de910eefbcfec42a450c.svg";
export { ForwardRef as ReactComponent };